import sliceCreator from '../../index.jsx';
import {GET_POST_MEDIA_FILES} from '../../../constants/index.jsx';
const _getAllPostMediaFilesAction = sliceCreator('GET_POST_MEDIA_FILES', GET_POST_MEDIA_FILES, 'get');

const { asyncAction: getAllPostMediaFilesAction, reducer, clearData: clearGetAllPostMediaFilesAction } = _getAllPostMediaFilesAction;

export default reducer;

export {
    getAllPostMediaFilesAction,
    clearGetAllPostMediaFilesAction
}